<template>
  <div class="content">
      <iframe :src="srcs" class="iframe-sty" :style="height"></iframe>
  </div>
</template>

<script>
import { route1 } from '../../api/apiRoute';
export default {
  data() {
    return { 
     srcs: '',
     roleGuids:[],
     winHeight: window.innerHeight,
      height: {
        height: '',
      },
      fbtToken:'',
    };
  },
  created() {  
    let self = this;
    self.src = '';
    self.getCommit(); 
    // setTimeout(function(){
    //     self.getSrc(); 
    // },1000);
    // var myDate = new Date();
    //     var month = myDate.getMonth() + 1;
    //     var strDate = myDate.getDate();
    //     if (month >= 1 && month <= 9) {
    //         month = "0" + month;
    //     }
    //     if (strDate >= 0 && strDate <= 9) {
    //         strDate = "0" + strDate;
    //     }
    //   var currentDate = myDate.getFullYear() + "-" + month + "-" + strDate + " 23:59:59"; 
    //   var timestamps = Date.parse(currentDate)/1000;
    //  console.log("今天晚上",timestamps);

    //     var timestamps1 = Date.parse(new Date())/1000; 
    //   console.log("当前时间",timestamps1);
      
    //   var expiresTime = localStorage.getItem("expiresTime");
    //   if (localStorage.getItem("wynToken") == null) { 
    //           this.loginWyn();
    //     }else{
    //           var time = Math.round(parseFloat(timestamps) - parseFloat(expiresTime)); 
    //           console.log(time);
    //           if(time == 0){
    //                 this.loginWyn();
    //           }
    //     }
    // window.location.href = process.env.FGBH5Api + 'index?appKey=' + process.env.sitappkey + '&' + self.toQueryString(data);
    // this.src = 'http://49.4.23.228:31980/reports/view/0ddb33e9-3211-4d96-9d25-ca34458dd8b9?display=singlepage&size=fitwidth&parampanel=top&theme=green&lng=zh&token=670550ae1460a86607190cd98b36eea4dcf0069a7e9d1f8c3af08b4b6936e6ef'
  },   
  watch: { 
    $route(to, from) { 
       this.getCommit(); 
    },
  }, 
  destroyed(){
    // window.removeEventListener('popstate',false);//false阻止默认事件
  },
  mounted(){    
    this.getCommit(); 
    window.onresize = () => { 
    return (() => { 
    this.winHeight = window.innerHeight 
        })
    } 
    this.height.height=this.winHeight-34+'px'; 
    // if (window.history && window.history.pushState) {
    //   history.pushState(null, null, document.URL);
    //   window.addEventListener('popstate',false);//false阻止默认事件
    // } 
  }, 
  methods: {
    //已选
    getCommit(){
      let self = this;
      self.menuid = [];
      let pwd = self.$md5('RAdmin20211224');
      let loginUrl = route1 + `/${serverConfig.msReportConfigService}`+'/user/login?logonUser=ExternalAccount&pwd='+pwd;
      // let item = {
      //   appSystemLabel:'FBT',
      //   pageIndex	:1,
      //   pageSize:-1,
      //   navigationPageGuid:self.ruleForm2.navigationPageGuid,
      //   roleGuid:self.ruleForm2.roleGuid
      // }
      fetch(loginUrl, {
                method: "POST",
                headers: {
                    "Content-type": "application/json",
                    // "Authorization": self.$store.state.token
                },
                // body:JSON.stringify(item)
            }
      )
      .then(function (res) { return res.json(); }) .then(function (res) {
        if(res.code == '00000'){
          self.fbtToken = res.data.token;
          self.getRoleGuidsByCurrentuser();
          self.getTenantOperationRelList();
        }else {
          self.$message.error(res.msg);
        }
      })
    },
    // goback(){ 
    //   if( this.$route.path == '/Login' || this.$route.path == '/reportQueryList-0'){
    //       this.$router.push('/reportQueryList-0'); 
    //   }
    // },
    //  getAuthorization(){
    //     var auth = 'Basic ' + window.btoa('integration' + ':' + 'eunGKas3Pqd6FMwx9eUpdS7xmz');
    //     //alert(auth);
    //     return auth;
    //   },
      // loginWyn(){
      //   var loginUrl = 'https://bi.csbr.cn/api/generatetoken?token=670550ae1460a86607190cd98b36eea4dcf0069a7e9d1f8c3af08b4b6936e6ef';
      //   var userName = 'admin';
      //   var password = 'csbr!1234';
      //   var myDate = new Date();
      //   var month = myDate.getMonth() + 1;
      //   var strDate = myDate.getDate();
      //   if (month >= 1 && month <= 9) {
      //       month = "0" + month;
      //   }
      //   if (strDate >= 0 && strDate <= 9) {
      //       strDate = "0" + strDate;
      //   }
      //   var currentDate = myDate.getFullYear() + "-" + month + "-" + strDate;
      //   var bo = {ExpireIn:currentDate + " 16:00:00",User:userName,Password:password,OrganizationPath:"/"};
  
      //   fetch(loginUrl, {
      //             method: "POST",
      //             headers: {
      //                 "Content-type": "application/json",
      //                 // "Authorization": this.getAuthorization()
      //             },
      //             // body: "grant_type=password&username=" + userName + "&password=" + password + "&OrganizationPath='/'"
      //             body:JSON.stringify(bo)
      //         }
      //   )
      //   .then(function (res) { return res.json(); }) .then(function (res) {
      //        var token = res.access_token;
      //        console.log(res)
      //      })
      // },
      // loginWyn(){
      //   var loginUrl = 'https://bi.csbr.cn/connect/token';
      //   var userName = 'admin';
      //   var password = 'csbr!1234';
      //   fetch(loginUrl, {
      //             method: "POST",
      //             headers: {
      //                 "Content-type": "application/x-www-form-urlencoded",
      //                 "Authorization": this.getAuthorization()
      //             },
      //             body: "grant_type=password&username=" + userName + "&password=" + password
      //         }
      //   )
      //   .then(function (res) { return res.json(); }) .then(function (res) {
      //        var token = res.access_token;
      //        alert(token);
      //      })
      // }, 
      
    getRoleGuidsByCurrentuser(){
      let self = this;
      self.api
      .get(`/${serverConfig.msCommonAdminPlatformAuthService}/role/data/get-roleguids-by-currentuser?tenantGuid=`+self.$store.state.guid)
      .then((res) => {
        if (res.data.code == serverConfig.REQUIRE_SUCCESS_CODE) {
          self.roleGuids = res.data.data;
          self.getTenantOperationRelList();
        } else {
          self.$message.error(res.data.msg);
        }
      }); 
    },
    //运营获取药企
    getTenantOperationRelList(){
      let self = this;  
      self.powerTenantNames = [];
      self.api.postJson(`/${serverConfig.msCustomerService}/tenant/data/get-tenant-operation-rel-list`,{'tenantGuid':self.$store.getters.getTenantGuid,'serviceTenantGuid':self.$store.getters.getTenantGuid,'isService':true}).then((res) => {
        if (res.data.code == serverConfig.REQUIRE_SUCCESS_CODE) {
          if(res.data.data && res.data.data.length < 12){
            res.data.data.forEach((i)=>{
              self.powerTenantNames.push(i.sendTenantName);
            })
          }else{
            self.powerTenantNames = [];
          }
          console.log(self.powerTenantNames);
          self.getSrc();
        } else {
          self.$message.error(res.data.msg);
        }
      });
    },
    getSrc(){ 
      let self = this; 
        let route =  this.$route.path; 
        let item = [];
        item.push(self.$store.state.guid);
        var userInfo = JSON.parse(localStorage.userInfo);
        let userGuid = [];
        userGuid.push(userInfo.staffGuid);
        let dp = {
            tenant_guid: item,
            user_guid:userGuid
        } 
        let str = JSON.stringify(dp);  
        let item1 = [];
        item1.push('3d3861e610cb40218d3ecf641147affd');
        let dp1 = {
            tenant_guid: item1
        } 
        let str1 = JSON.stringify(dp1);  
        var wynToken = JSON.parse(localStorage.getItem("wynToken"));
        // console.log(wynToken);

        if(localStorage.getItem("menuList")){  
           let menuList = JSON.parse(localStorage.getItem("menuList"));
           menuList.forEach(function(i) { 
                    if(i.children != null && i.children != ''){
                        i.children.forEach(function(j) {
                                    if(route == j.path){  
                                      j.src = j.src +'&userGuid='+ userInfo.userGuid +'&staffName='+ userInfo.staffName +'&roleGuids='+ self.roleGuids +'&powerTenantNames='+ self.powerTenantNames +'&token=' + self.fbtToken;
                                      // self.srcs = j.src +'&token=' + wynToken + '&dp='+ encodeURIComponent(str);
                                      self.srcs = j.src.indexOf('id=') > -1? j.src : (j.src +'&token=' + wynToken + '&dp='+ encodeURIComponent(str));
                                      console.log("二级",self.srcs);
                                    }
                               }) 
                    }else{  
                      if(route == i.path){  
                        i.src = i.src +'&userGuid='+ userInfo.userGuid +'&staffName='+ userInfo.staffName +'&roleGuids='+ self.roleGuids +'&powerTenantNames='+ self.powerTenantNames +'&token=' + self.fbtToken;
                        // self.srcs = i.src + '&token=' + wynToken + '&dp='+ encodeURIComponent(str);
                        self.srcs = i.src.indexOf('id=') > -1? i.src : (i.src +'&token=' + wynToken + '&dp='+ encodeURIComponent(str));
                        console.log("一级",self.srcs);
                      }
                    }
                })   
          //  console.log('src',self.srcs);
        }
        // self.srcs = 'https://bi.csbr.cn/reports/view/7bfd5a44-80ac-4663-b097-77353dc0be1b?display=pageless&parampanel=top&theme=forest&lng=zh&token=b3db1ec947e8831aa26c3a821a1859fb55f7b0ac655911568b3575afa2fadf2f&dp=%7B%22tenant_guid%22%3A%5B%2289a3261c262411ebad37fa163e4b37cf%22%5D%7D'
        
    } 
  },
};
</script>
<style  scoped>
 .content {
  margin: 0px;
 }
 .iframe-sty{ 
  width:100%;
  border:none;
  background:grey;
 }
</style>